import { Injectable, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { AtomTableIntl } from "@atomchat-io/ui-design-system";
import { TranslocoService } from "@jsverse/transloco";
import { switchMap, take } from "rxjs";

/**
 * The `atom_table` block of the catalogs. Typed explicitly because
 * `selectTranslateObject` defaults its generic to `any`.
 */
interface TableCopy {
    readonly select_all_rows: string;
    readonly select_row: string;
}

/**
 * Localizes the names of `atom-table`'s selection checkboxes, which the design
 * system ships in English ("Select all rows" / "Select row"). The other
 * `AtomTableIntl` labels keep the design system's defaults.
 *
 * A subscription rather than an `effect`, as in AtomBulkActionBarIntlService:
 * `selectTranslateObject` waits for the new bundle, while translating when
 * `langChanges$` fires would resolve against the previous language.
 */
@Injectable({
    providedIn: "root",
})
export class AtomTableIntlService extends AtomTableIntl {
    private readonly translocoService = inject(TranslocoService);

    constructor() {
        super();
        this.translocoService.langChanges$
            .pipe(
                // switchMap so switching twice in a row drops the first wait;
                // take(1) closes each wait, leaving langChanges$ as the trigger.
                switchMap(() =>
                    this.translocoService
                        .selectTranslateObject<TableCopy>("atom_table")
                        .pipe(take(1)),
                ),
                takeUntilDestroyed(),
            )
            .subscribe((copy) => {
                this.selectAllRowsLabel = copy.select_all_rows;
                this.selectRowLabel = copy.select_row;
                this.changes.next();
            });
    }
}
